/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Save_User_FailedInputs */

const en_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error saving user. ${i?.error}`)
};

const fr_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de l’enregistrement de l’utilisateur. ${i?.error}`)
};

const de_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Speichern des Benutzers. ${i?.error}`)
};

const it_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante il salvataggio dell'utente. ${i?.error}`)
};

const ru_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка сохранения пользователя. ${i?.error}`)
};

const es_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al guardar el usuario. ${i?.error}`)
};

const zh_cn2_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`保存用户时出错。${i?.error}`)
};

const ja_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ユーザーの保存中にエラーが発生しました。${i?.error}`)
};

const hi_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता को सहेजने में त्रुटि। ${i?.error}`)
};

const pt_pt2_team_manager_save_user_failed = /** @type {(inputs: Team_Manager_Save_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao salvar o usuário. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error saving user. {error}" |
*
* @param {Team_Manager_Save_User_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_user_failed = /** @type {((inputs: Team_Manager_Save_User_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_User_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_save_user_failed(inputs)
	if (locale === "de") return de_team_manager_save_user_failed(inputs)
	if (locale === "it") return it_team_manager_save_user_failed(inputs)
	if (locale === "ru") return ru_team_manager_save_user_failed(inputs)
	if (locale === "es") return es_team_manager_save_user_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_save_user_failed(inputs)
	if (locale === "ja") return ja_team_manager_save_user_failed(inputs)
	if (locale === "hi") return hi_team_manager_save_user_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_save_user_failed(inputs)
	return en_team_manager_save_user_failed(inputs)
});